import { NgForOf, NgIf } from '@angular/common';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatStepper, MatStepperModule } from '@angular/material/stepper';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { catchError, EMPTY, firstValueFrom, Observable, of, switchMap, tap } from 'rxjs';
import { AccountTypeDTO } from 'src/app/interfaces/accountType';
import { AppRegistrationDTO } from 'src/app/interfaces/appRegistration';
import { CaldavDTO, createCaldav } from 'src/app/interfaces/calDav';
import { CalendarDTO, createCalendar } from 'src/app/interfaces/calendar';
import { createICal, ICalDTO } from 'src/app/interfaces/iCal';
import { createCalendarIntegration, createCalendarIntegrationDTO, CalendarIntegrationDTO } from 'src/app/interfaces/calendarIntegration';
import { StandardResponseDTO } from 'src/app/interfaces/standardresponse';
import { UserDTO } from 'src/app/interfaces/user';
import { AccountTypeService } from 'src/app/services/account-type.service';
import { AppRegistrationService } from 'src/app/services/app-registration.service';
import { CaldavService } from 'src/app/services/caldav.service';
import { CalendarService } from 'src/app/services/calendar.service';
import { ErrorhandlingService } from 'src/app/services/errorhandling.service';
import { ICalService } from 'src/app/services/i-cal.service';
import { CalendarIntegrationService } from 'src/app/services/calendar-integration.service';
import { TokenStorageService } from 'src/app/services/token-storage.service';
import { ColorPickerComponent } from '../color-picker/color-picker.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FunctionsService } from 'src/app/services/functions.service';
import { MatProgressBarModule } from '@angular/material/progress-bar';

const googleLogoURL = "assets/Google.svg";

@Component({
  selector: 'app-create-consent',
  imports: [MatStepperModule, MatOptionModule, MatSelectModule, FormsModule, ReactiveFormsModule, NgIf, MatFormFieldModule, MatInputModule, MatButtonModule,
    NgForOf, MatIconModule, ColorPickerComponent, MatCheckboxModule, MatTableModule, MatTooltipModule, FormsModule, MatProgressBarModule
  ],
  templateUrl: './create-consent.component.html',
  styleUrls: ['./create-consent.component.scss'],
})
export class CreateConsentComponent implements OnInit {

  isLoggedIn: boolean;
  user: UserDTO;
  isOk: boolean;
  provider: string;
  accountType: AccountTypeDTO;
  accountTypes: AccountTypeDTO[];
  calendarIntegration: CalendarIntegrationDTO;
  calendarIntegrations: CalendarIntegrationDTO[];
  appRegistrations: AppRegistrationDTO[];
  appRegistration: AppRegistrationDTO;
  calDav: CaldavDTO = { id: -1, userId: -1, url: "", username: "", password: "" };
  caldavFailed: boolean = false;
  iCal: ICalDTO = { id: -1, userId: -1, url: '' };
  iCalSuccessful: boolean = false;
  calendarName: string = "";
  calendar: CalendarDTO;
  calDavCalendars: CalendarDTO[] = [];
  standardResponse: StandardResponseDTO;
  hide: boolean = true;
  @ViewChild(MatStepper) stepper: MatStepper;
  displayedColumns: string[] = ['Title', 'Show in Yournotes', 'Calendar color'];
  dataSource = new MatTableDataSource<CalendarDTO>();
  iCalError: boolean = false;
  iCalErrorMessage: string = "";
  emailControl = new FormControl('', [
    Validators.required,
    Validators.email
  ]);
  isLoading: boolean = false;


  constructor(private tokenStorageService: TokenStorageService, private router: Router, public dialogRef: MatDialogRef<CreateConsentComponent>, @Inject(MAT_DIALOG_DATA) data,
    private calendarIntegrationService: CalendarIntegrationService, private errorHandling: ErrorhandlingService, private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer, private appRegistrationService: AppRegistrationService, private accountTypeService: AccountTypeService, private iCalService: ICalService,
    private calendarService: CalendarService, private calDavService: CaldavService, public functions: FunctionsService) {
    this.calendarIntegrations = data;
    this.matIconRegistry.addSvgIcon("logo", this.domSanitizer.bypassSecurityTrustResourceUrl(googleLogoURL));
  }

  isAuthorized() {
    this.isLoggedIn = !!this.tokenStorageService.getToken();
    if (this.isLoggedIn) {
      this.user = this.tokenStorageService.getUser();
      this.isOk = true;
    } else {
      this.router.navigate(['home']);
    }
  }


  ngOnInit(): void {
    this.isAuthorized();
    this.getData().subscribe();
    this.calendarIntegration = createCalendarIntegrationDTO(-1, this.user.id, null, null, null, null, null, null, null, null, null, null, null, null, null, null);
    this.emailControl.valueChanges.subscribe((value) => {
      if (this.calendarIntegration) {
        this.calendarIntegration.email = value || '';
      }
    });


  }

  validateDescription() {
    if (this.calendarIntegration.description != null && this.calendarIntegration.description != "") {
      this.stepper.next();
    }
  }

  validateAccountType() {
    if (this.calendarIntegration.accountTypeId != null) {
      this.stepper.next();
    }
  }

  validateAppRegistration() {
    if (this.calendarIntegration.appRegistrationId != null) {
      this.stepper.next();
    }
  }

  validateCalDav() {
    this.calDav.userId = this.user.id;
    this.testCalDavAccount();
  }

  async testCalDavAccount() {
    this.isLoading = true;
    this.caldavFailed = false;
    const data = await firstValueFrom(this.calDavService.testCaldavAccount(this.calDav));
    if (data.url) {
      this.calDav.url = data.url;
      this.getCalDavCalendars();
    } else {
      this.caldavFailed = true;
    }
    this.isLoading = false;
  }

  async getCalDavCalendars() {
    const data = await firstValueFrom(this.calDavService.discoverCalDavCalendars(createCaldav(this.calDav.userId, this.calDav.url, this.calDav.username, this.calDav.password)));
    if (data) {
      this.calDavCalendars = data;
      this.dataSource.data = this.calDavCalendars;
      this.stepper.next();
    }
  }

  saveCalDavCalendars(): Observable<any> {
    this.calDavCalendars.forEach(async (cal) => {
      const data = await firstValueFrom(this.calendarService.saveCalendar(-1, createCalendar(this.user.id, this.calendarIntegration.id, "", cal.summary, cal.showInDashboard, cal.showInNotes, self.crypto.randomUUID(), self.crypto.randomUUID(), cal.color, cal.url)))
    })
    return of(null);
  }

  validate_iCal() {
    if (this.iCal.url.startsWith("webcal://")) {
      this.iCal.url = this.iCal.url.replace(/^webcal:\/\//i, 'https://');
    }
    if (this.iCal.url.startsWith("http")) {
      this.iCal.userId = this.user.id;
      this.testICalUrl();
    }
  }

  async testICalUrl() {
    this.isLoading = true;
    this.iCalError = false;
    this.iCalErrorMessage = "";
    try {
      const data = await firstValueFrom(this.iCalService.testICalUrl(this.iCal.url));
      if (data) {
        this.iCalSuccessful = true;
        this.stepper.next();
      } else {
        this.iCalError = true;
        this.iCalErrorMessage = "Invalid calendar url";
      }
    } catch (error) {
      this.iCalError = true;
      this.iCalErrorMessage = "Invalid calendar url";
    }
    this.isLoading = false;
  }

  saveICalDavFlow() {
    this.saveICalDavCalendarIntegrationAndCalendar().subscribe();
  }

  saveICalDav(): Observable<any> {
    if (this.accountType.code === 'ICAL') {
      return this.iCalService.saveICal(this.iCal.id, createICal(this.iCal.userId, this.iCal.url));
    } else {
      return this.calDavService.saveCaldav(this.calDav.id, createCaldav(this.calDav.userId, this.calDav.url, this.calDav.username, this.calDav.password));
    }
  }

  saveICalDavCalendarIntegrationAndCalendar(): Observable<any> {
    this.isLoading = true;
    return this.saveICalDav().pipe(
      tap({
        next: (data: any) => {
          if (this.accountType.code === 'ICAL') {
            this.iCal = data;
            this.calendarIntegration.iCalId = this.iCal.id;
          } else {
            this.calDav = data;
            this.calendarIntegration.calDavId = this.calDav.id;
          }
        }
      }),

      switchMap(() => {
        return this.calendarIntegrationService.saveCalendarIntegration(this.calendarIntegration.id, createCalendarIntegration(this.calendarIntegration.userId, this.calendarIntegration.accountTypeId,
          this.calendarIntegration.appRegistrationId, this.calendarIntegration.calDavId, this.calendarIntegration.iCalId, this.calendarIntegration.authorizationCode, this.calendarIntegration.accessToken, this.calendarIntegration.refreshToken,
          this.calendarIntegration.description, this.calendarIntegration.email));
      }),

      tap({
        next: (data: any) => {
          this.calendarIntegration = data;
        }
      }),

      switchMap(() => {
        if (this.accountType.code === 'ICAL') {
          return this.calendarService.saveCalendar(-1, createCalendar(this.user.id, this.calendarIntegration.id, "", this.calendarName, true, true, self.crypto.randomUUID(), self.crypto.randomUUID(), "#3b82f6", ""))
        } else {
          return this.saveCalDavCalendars();
        }
      }),

      tap({
        next: (data: any) => {
          if (this.accountType.code === 'ICAL') this.calendar = data;
        }
      }),

      switchMap(() => {
        this.isLoading = false;
        this.dialogRef.close();
        return null;
      }),

      tap({
        next: (data: any) => {
          if (data) {
          }
        }
      }),

      catchError(error => {
        this.isLoading = false;
        console.error("One of the API calls failed:", error);
        return EMPTY; // stop the stream
      })

    );
  }

  getData(): Observable<any> {
    return this.appRegistrationService.getAppRegistrations().pipe(

      tap({
        next: (data: any) => {
          this.appRegistrations = data;
        }
      }),

      switchMap(() => {
        return this.accountTypeService.getAccountTypes();
      }),

      tap({
        next: (data: any) => {
          this.accountTypes = data;

        }
      }),

      catchError(error => {
        console.error("One of the API calls failed:", error);
        return EMPTY; // stop the stream
      })

    );
  }

  selectAppRegistration(appRegistration: AppRegistrationDTO) {
    this.calendarIntegration.appRegistrationId = appRegistration.id;
    this.provider = appRegistration.provider;
  }

  selectAccountType(accountType: AccountTypeDTO) {
    this.calendarIntegration.accountTypeId = accountType.id;
    this.calendarIntegration.accountTypeName = accountType.description;
  }

  public objectComparisonFunction = function (option, value): boolean {
    if (option != null && value != null) {
      return option.id === value.id;
    } else {
      return false;
    }
  }

  requestConsent() {
    this.getConsent().subscribe();
  }

  getConsent(): Observable<any> {
    let calendarIntegrationWriteDTO = createCalendarIntegration(this.calendarIntegration.userId, this.calendarIntegration.accountTypeId,
      this.calendarIntegration.appRegistrationId, this.calendarIntegration.calDavId, this.calendarIntegration.iCalId, this.calendarIntegration.authorizationCode, this.calendarIntegration.accessToken, this.calendarIntegration.refreshToken,
      this.calendarIntegration.description, this.calendarIntegration.email);
    return this.calendarIntegrationService.saveCalendarIntegration(this.calendarIntegration.id, calendarIntegrationWriteDTO).pipe(

      tap({
        next: (data: any) => {
          this.calendarIntegration = data;
        }
      }),

      switchMap(() => {
        return this.calendarIntegrationService.getConsent(this.calendarIntegration, false);
      }),

      tap({
        next: (data: any) => {
          this.standardResponse = data;
          if (this.standardResponse.status == "GETCONSENT") {
            window.location.href = this.standardResponse.responseParameter;
          }
          this.dialogRef.close();
        }
      }),

      catchError(error => {
        console.error("One of the API calls failed:", error);
        return EMPTY; // stop the stream
      })

    );
  }

  getErrorMessage(): string {
    if (this.emailControl.hasError('required')) {
      return 'You must enter a value';
    }
    return this.emailControl.hasError('email') ? 'Not a valid email address' : '';
  }

  async saveYourNotesConfig() {
    const ci_data = await firstValueFrom(this.calendarIntegrationService.saveCalendarIntegration(this.calendarIntegration.id, createCalendarIntegration(this.calendarIntegration.userId, this.calendarIntegration.accountTypeId,
      this.calendarIntegration.appRegistrationId, this.calendarIntegration.calDavId, this.calendarIntegration.iCalId, this.calendarIntegration.authorizationCode, this.calendarIntegration.accessToken, this.calendarIntegration.refreshToken,
      this.calendarIntegration.description, this.calendarIntegration.email)));
    if (ci_data) {
      const calData = await firstValueFrom(this.calendarService.saveCalendar(-1, createCalendar(this.user.id, ci_data.id, "", "YourNotes", true, true, self.crypto.randomUUID(), self.crypto.randomUUID(), "#3378cc", "")));
      this.dialogRef.close();
    }



  }

}
